<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/applications/updatePayment/${inputs.id}`
            : `/accreditations/applications/updatePayment`
        "
      >
        <div class="row">
          <div class="col-sm-12" style="text-align: center">
            <legend class="text-primary">Aprobar pago de licencia</legend>
          </div>
          <div class="col-sm-12" style="text-align: center">
            <label>Archivo de pago de licencia:</label>
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'license_payment_file')"
                v-if="inputs.license_payment_file"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <!-- <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('receipt_return_report')"
                v-if="inputs.receipt_return_report"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button> -->
            </div>
          </div>
          <hr />
          <br />
          <div class="form-group col-12" style="text-align: center">
            <br />
            <label for="inputs_name">
              {{ $t("¿Aprobar pago de licencia?") }}
            </label>
            <app-input
              id="inputs_name"
              type="radio-buttons"
              v-model="inputs.is_approved"
              :list="list"
              :required="true"
            />
          </div>
          <div class="form-group col-12" v-if="inputs.is_approved == 0" style="text-align: center">
            <br />
            <label for="inputs_name">
              {{ $t("Observación") }}
            </label>
            <app-input
              id="inputs_observation"
              type="textarea"
              v-model="inputs.observation"
              :required="true"
            />
          </div>
        </div>
        <br />
      </form>
    </template>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationEmployeList: Array,
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  data() {
    return {
      preloader: false,
      inputs: {},
      request: {},
      modalId: "review-add-edit-modal",
      modalTitle: this.$t("add"),
      lastPosition: "",
      technical: "",
      formInstruction1: [
        this.$t("Si existen observaciones escribelas en el siguiente recuadro"),
      ],
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t(
        "Aprobación de Registro de Ingreso de solicitud de acreditación y Acuse Recibo"
      );
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    openDeleteModal(fileName) {
      this.inputs[fileName] = null;
    },

    afterSuccessFromGetEditData(response) {
      this.inputs.is_approved = 1;
      this.inputs = response.data;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    createOrUpdate(data) {
      this.axiosPost({
        url: "/accreditationreview/accreditationsFile/updatePayment",
        data,
      }).then((res) => {
        this.closeModal();
        if (res.status == 200) {
          if (this.inputs.id != null) {
            this.$toastr.s(this.$t("updated_success"));
          } else {
            this.$toastr.s(this.$t("created_success"));
          }
          this.$hub.$emit("reload-" + this.tableId);
        } else {
          if (this.inputs.id != null) {
            this.$toastr.e(this.$t("Error al intentar actualizar el registro"));
          } else {
            this.$toastr.e(this.$t("Error al intentar crear el registro"));
          }
        }
      });
    },

    openTb(item) {
      const w = window.open(item.path, "_blank");
      w.focus();
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].full_url, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          accreditationId: this.$store.state.evaluatorReview.accreditationId,
        };
      }
      // this.viewFile();
    },

    viewFile() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/generalTechnicalCoordination/generalTechnicalCoordinationReport/accreditationData/${this.$store.state.evaluatorReview.accreditationId}`;
      this.axiosGet(url).then((response) => {
        this.inputs = {
          accreditationId: this.$store.state.evaluatorReview.accreditationId,
          receipt_return_report: response.data.receipt_return_report,
          area_director_report: response.data.area_director_report,
          director_technical_report: response.data.director_technical_report,
        };
      });
    },
  },
};
</script>